import { render } from "./SniplyBrandSelect.vue?vue&type=template&id=3f82f767&scoped=true"
import script from "./SniplyBrandSelect.vue?vue&type=script&lang=js"
export * from "./SniplyBrandSelect.vue?vue&type=script&lang=js"

import "./SniplyBrandSelect.vue?vue&type=style&index=0&id=3f82f767&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f82f767"]])

export default __exports__